import { Component, h, Prop, Event, EventEmitter } from '@stencil/core';

@Component({
  tag: 'biel-input-option',
  styleUrl: 'biel-input-option.css',
  shadow: true,
})
export class BielInputOption {
  @Prop() isOpen: boolean = false;
  @Prop() label: string;

  @Event() toggleRequested: EventEmitter<void>;

  handleToggle(event: Event) {
    event.stopPropagation();
    this.toggleRequested.emit();
  }

  render() {
    return (
      <div class="biel-input-option-container">
        <button
          class="biel-input-option__button"
          part="button"
          onClick={(event) => this.handleToggle(event)}
          aria-expanded={this.isOpen ? 'true' : 'false'}
          aria-haspopup="true"
        >
          <span class="biel-input-option__button-text">{this.label}</span>
          <svg
            class={`biel-input-option__chevron ${this.isOpen ? 'open' : ''}`}
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3 4.5L6 7.5L9 4.5"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>

        {this.isOpen && (
          <div class="biel-input-option__dropdown" part="dropdown">
            <slot name="dropdown-content"></slot>
          </div>
        )}
      </div>
    );
  }
}
